import React, { ReactNode } from 'react';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, isAzureADEnabled, validateAzureConfig } from '../config/authConfig';

// Initialize MSAL instance only if Azure AD is enabled and properly configured
let msalInstance: PublicClientApplication | null = null;

if (isAzureADEnabled && validateAzureConfig()) {
  msalInstance = new PublicClientApplication(msalConfig);

  // Account selection logic (in case of multiple accounts)
  msalInstance.initialize().then(() => {
    const accounts = msalInstance!.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance!.setActiveAccount(accounts[0]);
    }

    // Listen for sign-in event and set active account
    msalInstance!.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        if (account) {
          msalInstance!.setActiveAccount(account);
        }
      }
    });
  }).catch((error) => {
    console.error('Failed to initialize MSAL:', error);
  });
} else if (isAzureADEnabled) {
  console.warn('Azure AD is enabled but configuration is invalid. Falling back to local authentication.');
}

interface MsalProviderWrapperProps {
  children: ReactNode;
}

const MsalProviderWrapper: React.FC<MsalProviderWrapperProps> = ({ children }) => {
  // If Azure AD is not enabled or not properly configured, render children without MSAL provider
  if (!isAzureADEnabled || !msalInstance) {
    return <>{children}</>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
};

export default MsalProviderWrapper;
export { msalInstance };